var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"order-complete"},[_c('div',[_c('h1',[_vm._v("Thanks for renting "+_vm._s(this.book))]),_c('router-link',{staticClass:"button return",attrs:{"to":"/books"}},[_vm._v("Back")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }